import { SvgIcon } from '@mui/material';

const PlusIconOutlined = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 31 31"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: props.width ?? '30px',
        height: props.height ?? '30px',
        fill: 'none',
      }}
    >
      <circle cx="15.6846" cy="15.3379" r="14.5" stroke="#8289A7" strokeOpacity="1" />
      <path
        d="M15.6846 9.33789V21.3379M21.6846 15.3379H9.68457"
        stroke="#8289A7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default PlusIconOutlined;
